import React, { useEffect, useState, useRef, useContext } from 'react';
import styles from './UserProfile.module.css';
import editIcon from '../../../assets/Imagess/ProfileEditIcon.svg';
import EditPhoto from '../../../assets/Imagess/EditPhoto.svg';
import BackIcon from '../../../assets/Imagess/BackIcon.svg';
import ProfilePsswordIcon from '../../../assets/Imagess/ProfilePsswordIcon.svg';
import HorizantalLine from '../../Atoms/Lines/HorizantalLine';
import PersonalInformation from '../../Molecules/Profile/PersonalInformation';
import PasswordChange from '../../Molecules/Profile/ChangePassword';
import policeManIcon from '../../../assets/Imagess/policeMan.svg';
import { toast } from 'react-toastify';
import {
  useProfileEdit,
  useChangePassword,
  useUserInfo,
} from '../../../Hooks/Profile';
import { useMutation } from 'react-query';
import axios from 'axios';
import { API_URL, securityHeaders } from '../../../Constants';
import { PageTitleContext } from '../../HOC/GeneralBody/GeneralBody';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';

const UserProfile = () => {
  const [mode, setMode] = useState('View');
  const fileInputRef = useRef(null);
  const HeaderAttr = useContext(PageTitleContext);

  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [mobile, setMobile] = useState();

  const [showPasswordChange, setShowPasswordChange] = useState(false);
  const [newPassword, setNewPassword] = useState(null);
  const [oldPassword, setOldPassword] = useState(null);
  const [disabledInputs, setDisabledInputs] = useState(true);
  //-------------------------------------------------------------
  const [image, setImage] = useState();
  const [ImgSrc, setImgSrc] = useState();
  const [editImage, setEditImage] = useState();

  const { mutate: changePassword, isLoading: ischangePasswordLoading } =
    useChangePassword();
  const { mutate: editProfile, isLoading: isProfileLoading } = useProfileEdit();

  const { data: UserById, refetch: refetchUserById } = useUserInfo(
    localStorage.getItem('userId')
  );
  //-------------------------------------
  useEffect(() => {
    if (mode === 'Edit') {
      HeaderAttr.setMoveRight('40px');
      HeaderAttr.setPathName('تعديل الملف الشخصي');
      setDisabledInputs(false);
    } else {
      refetchUserById();
      HeaderAttr.setMoveRight('2px');
      HeaderAttr.setPathName('ملفي الشخصي');
      setDisabledInputs(true);
    }
  }, [mode]);

  //------------------------------------------------------

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  //------------------------------------------------------
  const ChangePassword = () => {
    let obj = {
      oldPassword: oldPassword,
      newPassword: newPassword,
    };
    //
    changePassword(obj, {
      onSuccess: (data) => {
        toast.success('تم تحديث كلمة المرور');
        setShowPasswordChange('');
      },
      onError: (error) => {
        toast.error('كلمة المرور الحالية غير صحيحة');
      },
    });
  };
  //----------------------
  const updateProfile = useMutation({
    mutationFn: (fields) => {
      return axios.post(API_URL + `/api/Users/CreateUser`, fields, {
        headers: securityHeaders,
      });
    },
    onSuccess: (data) => {
      toast.success('تم التحديث بنجاح');
      setMode('View');
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const updateProfileImage = useMutation({
    mutationFn: (fields) => {
      return axios.post(API_URL + `/api/Users/UploadUserImage`, fields, {
        headers: securityHeaders,
      });
    },
    onSuccess: (data) => {},
    onError: (error) => {
      toast.error('خطأ في تحميل الصورة');
    },
  });

  const handleForSubmit = () => {
    if (!isValidEmail(email)) {
      toast.error('أدخل بريد إلكتروني صالح');
    } else if (!firstName || !lastName || !email) {
      toast.error('يرجى ملء جميع الحقول الإلزامية');
    } else {
      let obj = {
        userId: localStorage.getItem('userId'),
        fullNameEn: firstName,
        fullNameAr: lastName,
        email: email,
        mobile: mobile,
        username: UserById?.data?.authenticatedUser?.userName,
        pages: UserById?.data?.userRoles?.map((item) => item.pageId),
      };

      updateProfile.mutate(obj);

      if (image) {
        var formData = new FormData();
        formData.append('UserId', localStorage.getItem('userId'));
        formData.append('Image', image);
        updateProfileImage.mutate(formData);
      }
    }
  };

  //----------------------

  const handleUploadImageClick = () => {
    mode === 'Edit' && fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
  };

  useEffect(() => {
    if (
      image &&
      ['image/png', 'image/jpeg', 'image/svg+xml'].indexOf(image.type) === -1
    ) {
      toast.error('فقط ملفات [PNG، JPG، SVG] مسموح بها');
    } else {
      if (editImage && !image) {
        setImgSrc(editImage);
      } else if ((editImage && image) || (!editImage && image)) {
        setImgSrc(URL.createObjectURL(sanitizeAndValidateUrl(image)));
      }
    }
  }, [image, editImage]);
  //-----------------------------------------------
  useEffect(() => {
    refetchUserById();
  }, []);

  useEffect(() => {
    //
    setFirstName(UserById?.data?.authenticatedUser?.fullName_En);
    setLastName(UserById?.data?.authenticatedUser?.fullName_AR);
    setEmail(UserById?.data?.authenticatedUser?.email);
    setMobile(UserById?.data?.authenticatedUser?.mobile);
    setEditImage(
      UserById?.data?.authenticatedUser?.url +
        UserById?.data?.authenticatedUser?.userImage
    );
  }, [UserById]);
  //-----------------------------------------------

  return (
    <div className={styles['profileContainer']}>
      <div className={styles['first-container']}>
        {/* {mode === 'Edit' && (
          <img
            src={BackIcon}
            className={styles['BackIcon']}
            onClick={() => {
              setMode('View');
            }}
            alt={''}
          />
        )} */}

        <div className={styles['img-container']}>
          <img
            src={ImgSrc ? ImgSrc : policeManIcon}
            alt='icon'
            className={styles['img']}
          />
          {mode === 'Edit' && (
            <img
              src={EditPhoto}
              alt='icon'
              onClick={handleUploadImageClick}
              className={styles['icon']}
            />
          )}
          <input
            type='file'
            className='form-control form-body-input'
            style={{ display: 'none' }}
            ref={fileInputRef}
            onChange={handleImageChange}
            required
          />
        </div>

        <div className={styles['subcontainer']}>
          <div className={styles['title-container']}>
            <h3>{firstName + ' ' + lastName}</h3>
            {mode === 'View' ? (
              <div onClick={() => setMode('Edit')}>
                <img src={editIcon} className='icon-img' alt='icon' />
                تعديل الملف الشخصي
              </div>
            ) : (
              <div>
                <div onClick={() => setShowPasswordChange(true)}>
                  <img
                    src={ProfilePsswordIcon}
                    className='icon-img'
                    alt='icon'
                  />
                  تغيير كلمة المرور
                </div>
                &nbsp;
                <div
                  onClick={() => {
                    handleForSubmit();
                  }}
                >
                  <img src={editIcon} className='icon-img' alt='icon' />
                  حفظ التغييرات
                </div>
              </div>
            )}
          </div>

          <HorizantalLine />
          <div className={styles['details-subcontainer']}>
            <h4>الصفحات المعينة</h4>
            <h5>
              {UserById?.data?.userRoles?.map((item) => item.name + ', ')}
            </h5>
          </div>
        </div>
      </div>

      <div className={styles['sub-container']}>
        <div className={styles['personal-container']}>
          <h3>المعلومات الشخصية </h3>
          <PersonalInformation
            firstName={firstName}
            lastName={lastName}
            email={email}
            mobile={mobile}
            setEmail={setEmail}
            setFirstName={setFirstName}
            setLastName={setLastName}
            setMobile={setMobile}
            disabledInputs={disabledInputs}
          />
        </div>
      </div>

      {showPasswordChange && (
        <PasswordChange
          setNewPassword={setNewPassword}
          setOldPassword={setOldPassword}
          handleSave={() => ChangePassword()}
          handleOnClose={() => setShowPasswordChange('')}
          ChangePassword={ChangePassword}
        />
      )}
    </div>
  );
};

export default UserProfile;
